import axios from "../api";
export const getEvolvedPlayers = async ({ sort, playerRoleId, }) => {
    const role = playerRoleId ? `&player-role-id=${playerRoleId}` : "";
    const res = await axios.get(`/evolved-players?sort-${sort}${role}`);
    return res.data;
};
//# sourceMappingURL=getEvolvedPlayers.js.map